<template lang="html">
  <div :class="['progress-job', job.status]">
    <div class="progress-wrapper">
      <div
        v-if="job.status === 'active'"
        class="wrapper-circle"
      >
        <svg
          :width="radialProgressRadius + 2"
          :height="radialProgressRadius + 2"
          class="radial-progress"
        >
          <circle
            :cx="radialProgressRadius / 2 + 1"
            :cy="radialProgressRadius / 2 + 1"
            :r="radialProgressRadius / 2"
            :stroke-width="2"
          />
          <circle
            :style="{strokeDashoffset: radialProgress}"
            :cx="radialProgressRadius / 2 + 1"
            :cy="radialProgressRadius / 2 + 1"
            :r="radialProgressRadius / 2"
            :stroke-width="2.5"
            class="path"
          />
        </svg>
        <span class="displayed-progress">{{ displayedProgress }}</span>
      </div>

      <button
        v-if="isCompleted"
        class="download"
        @click="download()"
      >
        <span class="UI-icon UI-download" />
      </button>

      <div class="wrapper-left">
        <span class="filename">
          {{ job.data.general.filename }}<span
            v-if="job.status === 'failed'"
            class="UI-icon UI-triangle"
          />
        </span>

        <copy-clipboard
          v-if="isCompleted"
          :to-copy="job.returnvalue.url"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CopyClipboard from '@/components/CopyClipboard'
export default {
  name: 'ProgressJob',

  components: { CopyClipboard },

  props: {
    job: { type: Object, required: true }
  },

  data () {
    return {
      radialProgressRadius: 36
    }
  },

  computed: {
    displayedProgress () {
      return `${this.$n((this.job.progress * 100), 'progressFixed')}`
    },

    radialProgress () {
      return this.job.progress / 1 * -114
    },

    isCompleted () {
      return this.job.status === 'completed'
    }
  },

  methods: {
    download () {
      window.open(this.job.returnvalue.url)
    }
  }
}
</script>

<style lang="scss">
@import "~@/assets/styles/variables";
@import "~@/assets/styles/buttons";

$circle-background: #d6dadc;
$circle-color-off: #494d6d;
$circle-color-on: #0ba8fd;
$circle-color-success: #14c6ab;
$circle-size: 24px;
$transition-length: 150ms;

.progress-job{
  &.completed + .progress-job{
    margin-top: 18px;
  }

  & + .progress-job{
    margin-top: 9px;
  }

  &:not(.completed){
    font-size: 14px;
  }

  &.failed{
    .wrapper-left{
      .filename{
        .UI-icon{
          margin-left: 7px;
          color: tomato;
          font-size: 18px;
          vertical-align: middle;
        }
      }
    }
  }

  .progress-wrapper{
    width: 100%;
    display: flex;
    align-items: center;
  }

  .wrapper-left{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    margin-left: 16px;
    overflow: hidden;

    .filename{
      white-space: nowrap;
      margin-bottom: 4px;
      color: #A2b4b4;
    }
  }

  .wrapper-circle{
    position: relative;

    .displayed-progress{
      position: absolute;
      top: 50%; left: 50%;
      transform: translate(-50%, -50%);
      font-size: 11px;
      line-height: 11px;
      color: #A2b4b4;
    }
  }

  .radial-progress {
    shape-rendering: geometricPrecision;
    display: block;;

    circle{
      fill: none;
      stroke: $circle-color-on;

      &.path {
        stroke: $circle-color-off;
        stroke-dasharray: 800;
        stroke-dashoffset: 0;
        transition: 350ms all;
      }
    }
  }

  button{
    @extend %reset-button;
    color: white;

    &.download{
      background: $circle-color-success;
      min-width: 48px;
      min-height: 48px;
      border-radius: 100%;

      .UI-icon{
        font-size: 24px
      }
    }
  }
}
</style>
